export default __webpack_public_path__ + "static/media/17-100.56b60a68.jpg";